module.exports = __webpack_public_path__ + "img/china.1dc0b171.svg";